import { createFileRoute } from '@tanstack/react-router'

import { ClassificationListView } from '@/components/Internal/ProductClassification/ClassificationListView'

export const Route = createFileRoute(
  '/internal/system/administration/classifications/design-lines',
)({
  component: () => <ClassificationListView kind="DESIGN_LINE" />,
})
